import React, { useState, useEffect } from 'react';
import {
  useMemorizeFilters,
  POSSIBLE_FILTERS_ENTITIES
} from 'hooks/useMemorizeInputsFilters';
import { useForm, Controller, useWatch } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { toast } from 'react-toastify';
import Pagination from 'components/Pagination';
import UserService from '../../../User/service';
import TrunkService from '../../../Trunk/service';
import ExtensionService from '../../../Extension/service';
import ReportService from './service';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import FlexSelect from 'components/Inputs/FlexSelect';
import Loader from 'react-loader-spinner';
import HourMaskMMHHSS from '../../../../components/Inputs/HourMaskMMHHSS.js';
import DatePicker from '../../../../components/Inputs/DatePicker.js';
import ReportAnalythical from './tables/Analytical';
import ReportSynthetic from './tables/Synthetic';
import { definedMessageGeneratedInPdfCsvDownloads } from '../../utils/definedMessageGeneratePdfCsv';
import { disabledDownloadButtonCsvAndPdf } from '../../utils/disabledDownloadButtonCsvAndPdf';
import ReportDetailedSynthetic from './tables/DetailedSynthetic';
import * as fileSaver from 'file-saver';
import { v4 as uuid } from 'uuid';
import { format, startOfMonth } from 'date-fns';
import { Tooltip } from '@material-ui/core';
import { useSelector } from 'react-redux';
import {
  reportOptions,
  statusCall,
  groupByOptions,
  daysOfWeek
} from '../utils/types';
import { dateRules, hourRules } from '../utils/rulesValidation';
import ddrService from '../../../../views/Ddrs/service';
import { useGetQueues } from 'views/Report/hooks/useGetQueues';

import {
  Container,
  Row,
  Card,
  Form,
  Col,
  CardHeader,
  Button,
  CardBody,
  Input
} from 'reactstrap';

import {
  ImageButtonContainer,
  ImageButton,
  ImageSize
} from '../../../../assets/styles/image_style';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import { useGetTeamsFiltered } from 'hooks/useGetTeamsFiltered';
import { UserFlexSelect } from '../../../../components/UserFlexSelect';
import { ItemPerPageSelect } from 'components/Inputs/ItemPerPageSelect';
import { AudioMultipleDownload } from 'components/AudioMultipleDownload';
import { ClearFiltersButton } from 'components/ClearFiltersButton';

const ReceivedCallReport = () => {
  const { control, handleSubmit, errors, setValue, watch, getValues } =
    useForm();
  const { getMemorizedFilters, memorizeFilters, clearMemorizedFilters } =
    useMemorizeFilters(
      POSSIBLE_FILTERS_ENTITIES.REPORT_CALL_CENTER_INCOMING_CALLS
    );
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const [trunks, setTrunks] = useState([]);
  const [usersShowDisable, setUsersShowDisable] = useState(true);
  const [users, setUsers] = useState([]);
  const [extensios, setExtensions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingReport, setLoadingReport] = useState(false);
  const reportType = watch('reportType');
  const [ReportTypeAnalytical, setReportTypeAnalytical] = useState([]);
  const [ReportTypeSynthetic, setReportTypeSynthetic] = useState([]);
  const [ReportTypeDetailedSynthetic, setReportTypeDetailedSynthetic] =
    useState([]);
  const [media, setMedia] = useState('');
  const showDisables = !!useWatch({ control, name: 'disable' });
  const { queues } = useGetQueues(showDisables, setLoading);
  const { teams } = useGetTeamsFiltered();

  const [ddrs, setDdrs] = useState();
  const [dataToSend, setDataToSend] = useState({});
  const [quantity, setQuantity] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const limitGenerationPDF = parseInt(
    process.env.REACT_APP_LIMIT_GENERATION_PDF || 25000
  );
  const [messagemGeneratePdf, setMessagemGeneratePdf] = useState();
  const [messagemGenerateCsv, setMessagemGenerateCsv] = useState();
  const [messagemGenerateXlsx, setMessagemGenerateXlsx] = useState();
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isMultiDownload, setIsMultiDownload] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    ExtensionService.getAllShowDisableNew(showDisables)
      .then((response) => {
        setExtensions(response.data.data);
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  }, [showDisables]);

  useEffect(() => {
    ddrService
      .getAll()
      .then((response) => {
        const data = response.data.data;

        const ddrData = data.map((value) => ({
          label: value.ddr,
          id: value.id
        }));
        setDdrs(ddrData);
      })
      .catch((error) => {
        console.log('error:> ', error);
      });
  }, []);

  const getTrunk = () => {
    setLoading(true);
    TrunkService.getAll()
      .then((response) => {
        setTrunks(response.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log('err: ' + err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getTrunk();
  }, []);

  useEffect(() => {
    getUser(true);
  }, [usersShowDisable]);

  const getUser = (showDisable = false) => {
    if (!showDisable) {
      setLoading(true);
    }
    UserService.getAll(false, undefined, undefined, usersShowDisable)
      .then((response) => {
        setUsers(response.data.data);
        if (!showDisable) {
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log('err: ' + err);
        if (!showDisable) {
          setLoading(false);
        }
      });
  };

  //messagemGeneratePdfCsv
  useEffect(() => {
    const message = definedMessageGeneratedInPdfCsvDownloads(
      quantity,
      limitGenerationPDF
    );

    setMessagemGeneratePdf(message.pdfMessage);
    setMessagemGenerateCsv(message.csvMessage);
    setMessagemGenerateXlsx(message.xlsxMessage);
  }, [quantity, limitGenerationPDF]);

  const clearData = () => {
    setReportTypeAnalytical([]);
    setReportTypeSynthetic([]);
    setReportTypeDetailedSynthetic([]);
    setDataToSend({});
    setQuantity(0);
  };

  const toISOFormat = (dateTimeString, bar = false) => {
    const [date] = dateTimeString.split(' ');
    const [DD, MM, YYYY] = date.split('/');

    if (bar) return `${MM}/${DD}/${YYYY}`;
    return `${MM}-${DD}-${YYYY}`;
  };

  const getFormatedType = (value) => {
    switch (value) {
      case 1:
        return 'analytical';
      case 2:
        return 'synthetic';
      case 3:
        return 'detailedsynthetic';
      default:
        break;
    }
  };

  const getDataDTO = (data) => {
    let formatedData;

    formatedData = {
      ...data,
      dateBegin: `${toISOFormat(data.dateBegin)} ${data.timeStart}`,
      dateEnd: `${toISOFormat(data.dateEnd)} ${data.timeEnd}`,
      timeStart: data.timeStart.replace(/:/g, ''),
      timeEnd: data.timeEnd.replace(/:/g, '')
    };

    if (formatedData.queue.length > 0)
      formatedData = { ...formatedData, queue: formatedData.queue.join(',') };
    else delete formatedData.queue;
    if (!formatedData.daysOfWeek) delete formatedData.daysOfWeek;
    if (formatedData.groupbyTeam)
      if (formatedData.groupbyTeam.length > 0)
        formatedData = {
          ...formatedData,
          groupbyTeam: formatedData.groupbyTeam.join(',')
        };
      else delete formatedData.groupbyTeam;

    if (formatedData.groupby) {
      if (formatedData.groupby.length > 0)
        formatedData = {
          ...formatedData,
          groupby: formatedData.groupby.join(',')
        };
      else delete formatedData.groupby;
    } else delete formatedData.groupby;

    if (formatedData.agent.length !== 0) {
      formatedData.agent = formatedData.agent.join(',') || null;
    }

    if (!formatedData.agent) delete formatedData.agent;

    users.find((user) => {
      if (user.agent_code === formatedData.agent) {
        formatedData.agentName = user.name;
      }
    });

    if (!formatedData.agentName) delete formatedData.agentName;
    if (!formatedData.carrier) delete formatedData.carrier;
    if (!formatedData.disposition) delete formatedData.disposition;
    if (!formatedData.dst) delete formatedData.dst;
    if (!formatedData.origin) delete formatedData.origin;
    if (reportType !== 3) {
      delete formatedData.groupby;
      delete formatedData.maxWaitTime;
      delete formatedData.allCalls;
    }
    if (!formatedData.maxWaitTime) delete formatedData.maxWaitTime;
    if (!formatedData.ddr) delete formatedData.ddr;
    setDataToSend(formatedData);
    return formatedData;
  };

  const getReports = (typeReport, dataToSend, page, useLoader = true) => {
    setLoadingReport(useLoader);

    if (media === 'pdf' || media === 'csv') {
      ReportService.getDownloads(typeReport, 1, media, dataToSend)
        .then((res) => {
          if (res.data.size <= 11)
            toast.info('Nenhum registro foi encontrado!');
          else {
            fileSaver.saveAs(
              new Blob([res.data], { type: res.headers['content-type'] }),
              media === 'pdf'
                ? 'Relatório_de_Chamadas_Recebidas_CallCenter.pdf'
                : 'Relatório_de_Chamadas_Recebidas_CallCenter.csv'
            );
          }
          setLoadingReport(false);
        })
        .catch((err) => {
          toast.error(err || `Erro ao gerar documento ${media}`, {
            autoClose: 3000,
            closeOnClick: true
          });
          setLoadingReport(false);
        });
      setMedia('');
    } else if (media === 'xlsx') {
      ReportService.getDownloadCallInXlsx(dataToSend)
        .then((res) => {
          if (res.data.size <= 11)
            toast.info('Nenhum registro foi encontrado!');
          else {
            fileSaver.saveAs(
              new Blob([res.data], { type: 'application/octet-stream' }),
              'Relatório_de_Chamadas_Recebidas_CallCenter.xlsx'
            );
          }
          setLoadingReport(false);
        })
        .catch((err) => {
          toast.error(err || `Erro ao gerar documento ${media}`, {
            autoClose: 3000,
            closeOnClick: true
          });
          setLoadingReport(false);
        });
      setMedia('');
    } else {
      ReportService.getAllReportsType(
        typeReport,
        page,
        dataToSend,
        itemsPerPage
      )
        .then((res) => {
          switch (typeReport) {
            case 'analytical':
              if (res.data.data.quantityCall === 0)
                toast.info('Nenhum registro foi encontrado!');
              else {
                res.data.data.listCallInAnalyticalDTO.forEach((el, index) => {
                  res.data.data.listCallInAnalyticalDTO[index].uuid = uuid();
                  res.data.data.listCallInAnalyticalDTO[index].id = el.acctid;
                });
                setReportTypeAnalytical(res.data.data);
                setQuantity(res.data.data.quantityCall);
              }
              break;
            case 'synthetic':
              if (
                res.data.data.listCallInSyntheticDTO.length === 0 &&
                res.data.data.listCallForHourDto.length === 0 &&
                res.data.data.listCallForQueueDto.length === 0
              )
                toast.info('Nenhum registro foi encontrado!');
              else {
                res.data.data.listCallForQueueDto.forEach((el, index) => {
                  res.data.data.listCallForQueueDto[index].uuid = uuid();
                });
                setQuantity(res.data.data.listCallInSyntheticDTO.length);
                setReportTypeSynthetic(res.data.data);
              }
              break;
            case 'detailedsynthetic':
              if (res.data.data.quantity === 0)
                toast.info('Nenhum registro foi encontrado!');
              else {
                res.data.data.listCallDetailedSyntheticCallCenterDTO.forEach(
                  (el, index) => {
                    res.data.data.listCallDetailedSyntheticCallCenterDTO[
                      index
                    ].uuid = uuid();
                  }
                );
                setReportTypeDetailedSynthetic(res.data.data);
                setQuantity(res.data.data.quantity);
              }
              break;
            default:
              break;
          }
          setLoadingReport(false);
        })
        .catch((err) => {
          toast.error(err, {
            autoClose: 3000,
            closeOnClick: true
          });
          setLoadingReport(false);
        });
    }
  };

  const onSubmit = (data, isNotFromUseEffect = true) => {
    clearData();
    try {
      let pageSavedOnMemory = 1;

      if (!isNotFromUseEffect) {
        pageSavedOnMemory = getMemorizedFilters()?.page ?? 1;
      }

      setActivePage(pageSavedOnMemory);
      memorizeFilters({ ...data, page: pageSavedOnMemory });
      const formatedData = getDataDTO(data);
      const formatedType = getFormatedType(reportType);
      getReports(formatedType, formatedData, pageSavedOnMemory, true);
    } catch (err) {
      toast.error(err || 'Ops, ocorreu um erro!', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  useEffect(() => {
    clearData();
  }, [reportType]);

  useEffect(() => {
    if (users.length > 0) {
      const formValues = getValues();
      onSubmit(formValues, false);
    }
  }, [users]);

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const handlePageChange = (page) => {
    const prevFilters = getMemorizedFilters();
    memorizeFilters({ ...prevFilters, page });
    setActivePage(page);
    getReports(getFormatedType(reportType), dataToSend, page, true);
  };

  const getDateBegin = () => {
    const date = new Date();
    const firstDayMonth = new Date(
      date.getFullYear('pt-br'),
      date.getMonth('pt-br'),
      1
    );
    const dateBegin = format(startOfMonth(firstDayMonth), 'dd/LL/yyyy');
    return dateBegin;
  };

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedRows([...selectedRows, row]);
    } else {
      setSelectedRows(selectedRows.filter((x) => x.id !== row.id));
    }
  };

  const handleOnSelectAll = (isSelect, rows) => {
    if (isSelect) {
      setSelectedRows(rows);
    } else {
      setSelectedRows([]);
    }
  };

  const handleMultiDownload = async () => {
    getReports(getFormatedType(reportType), dataToSend, activePage, true);
    setIsMultiDownload(!isMultiDownload);
  };

  const toggleMultiDownload = async () => {
    const idsArray = selectedRows.map((audio) => audio.uniqueid);
    const dataDto = { uniqueids: idsArray };
    const response = await ReportService.downloadMultiAudio(dataDto);
    fileSaver.saveAs(response.data, 'Cahamadas Recebidas Callcenter.zip');
  };

  const handleReset = () => {
    const defaultFieldValues = {
      carrier: '',
      agent: '',
      origin: '',
      queue: '',
      dst: '',
      dateBegin: getDateBegin(),
      timeStart: '00:00:00',
      dateEnd: new Date().toLocaleDateString('pt-br'),
      timeEnd: '23:59:59',
      disposition: '',
      teamId: '',
      daysOfWeek: '',
      reportType: 1,
      ddr: '',
      groupBy: '',
      maxWaitTime: '',
      allCalls: false,
      disable: false
    };

    for (const key in defaultFieldValues) {
      setValue(`${key}`, defaultFieldValues[key]);
    }

    clearMemorizedFilters();
  };

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        showBackArrow="not"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Relatório de Chamadas Recebidas - Callcenter</h3>
                </CardHeader>
                <CardBody>
                  {loading ? (
                    <Row className="justify-content-md-center">
                      <Loader
                        type="TailSpin"
                        color={systemConfiguration.primary_color}
                        height={100}
                        width={100}
                      />
                    </Row>
                  ) : (
                    <>
                      <Form
                        className="needs-validation"
                        onSubmit={handleSubmit(onSubmit)}
                      >
                        <ClearFiltersButton handleOnClick={handleReset} />
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Operadora
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={trunks}
                                  isMulti={false}
                                  isClearable={true}
                                  value={props.value}
                                  closeMenuOnSelect={true}
                                  valueController={setValue}
                                  fieldName="carrier"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="carrier"
                              defaultValue={
                                getMemorizedFilters()?.carrier ?? ''
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">Agente</label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={users}
                                  isMulti={true}
                                  isClearable={true}
                                  value={props.value}
                                  valueController={setValue}
                                  closeMenuOnSelect={false}
                                  fieldName="agent"
                                  labelName="name"
                                  valueName="agent_code"
                                />
                              )}
                              control={control}
                              name="agent"
                              defaultValue={getMemorizedFilters()?.agent ?? ''}
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">Origem</label>
                            <Controller
                              as={Input}
                              control={control}
                              name="origin"
                              defaultValue={getMemorizedFilters()?.origin ?? ''}
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Destino
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={extensios}
                                  isMulti={false}
                                  isClearable={true}
                                  value={props.value}
                                  valueController={setValue}
                                  closeMenuOnSelect={true}
                                  fieldName="dst"
                                  labelName="extension_number"
                                  valueName="extension_number"
                                />
                              )}
                              control={control}
                              name="dst"
                              defaultValue={getMemorizedFilters()?.dst ?? ''}
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Data inicial*
                            </label>
                            <Controller
                              render={(props) => (
                                <DatePicker
                                  fieldName="dateBegin"
                                  valueController={setValue}
                                  defaultValue={props.value}
                                />
                              )}
                              control={control}
                              name="dateBegin"
                              rules={dateRules}
                              defaultValue={
                                getMemorizedFilters()?.dateBegin ??
                                getDateBegin()
                              }
                            />
                            <ErrorMessage
                              errors={errors}
                              name="dateBegin"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Hora inicial*
                            </label>
                            <Controller
                              render={(props) => (
                                <HourMaskMMHHSS
                                  valueController={setValue}
                                  fieldName="timeStart"
                                  value={props.value}
                                />
                              )}
                              control={control}
                              name="timeStart"
                              rules={hourRules}
                              defaultValue={
                                getMemorizedFilters()?.timeStart ?? '00:00:00'
                              }
                            />
                            <ErrorMessage
                              errors={errors}
                              name="timeStart"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Data final*
                            </label>
                            <Controller
                              render={(props) => (
                                <DatePicker
                                  fieldName="dateEnd"
                                  valueController={setValue}
                                  defaultValue={props.value}
                                />
                              )}
                              control={control}
                              name="dateEnd"
                              defaultValue={
                                getMemorizedFilters()?.dateEnd ??
                                new Date().toLocaleDateString('pt-br')
                              }
                              rules={{
                                ...dateRules,
                                validate: (value) => {
                                  if (
                                    new Date(toISOFormat(value, true)) <
                                    new Date(
                                      toISOFormat(
                                        getValues()['dateBegin'],
                                        true
                                      )
                                    )
                                  ) {
                                    return 'A data final não pode ser anterior à inicial!';
                                  } else {
                                    return true;
                                  }
                                }
                              }}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="dateEnd"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Hora final*
                            </label>
                            <Controller
                              render={(props) => (
                                <HourMaskMMHHSS
                                  valueController={setValue}
                                  fieldName="timeEnd"
                                  value={props.value}
                                />
                              )}
                              control={control}
                              name="timeEnd"
                              rules={hourRules}
                              defaultValue={
                                getMemorizedFilters()?.timeEnd ?? '23:59:59'
                              }
                            />
                            <ErrorMessage
                              errors={errors}
                              name="timeEnd"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Status da chamada
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={statusCall}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  isClearable={true}
                                  closeMenuOnSelect={true}
                                  fieldName="disposition"
                                  labelName="label"
                                  valueName="value"
                                />
                              )}
                              control={control}
                              name="disposition"
                              defaultValue={
                                getMemorizedFilters()?.disposition ?? ''
                              }
                            />
                          </Col>

                          <Col md="6">
                            <label className="form-control-label">
                              Fila(s)
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={queues}
                                  isMulti={true}
                                  isClearable={true}
                                  value={props.value}
                                  closeMenuOnSelect={false}
                                  valueController={setValue}
                                  fieldName="queue"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="queue"
                              defaultValue={getMemorizedFilters()?.queue ?? ''}
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">Equipe</label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  isClearable={true}
                                  dataOptions={teams}
                                  isMulti={false}
                                  closeMenuOnSelect={true}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="teamId"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="teamId"
                              defaultValue={getMemorizedFilters()?.teamId ?? ''}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="teamId"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>

                          <Col md="6">
                            <label className="form-control-label">
                              Dia da semana
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={daysOfWeek}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  closeMenuOnSelect={true}
                                  isClearable={true}
                                  fieldName="daysOfWeek"
                                  labelName="label"
                                  valueName="value"
                                />
                              )}
                              control={control}
                              name="daysOfWeek"
                              defaultValue={
                                getMemorizedFilters()?.daysOfWeek ?? ''
                              }
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Tipo de Relatório
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={reportOptions}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  closeMenuOnSelect={true}
                                  fieldName="reportType"
                                  labelName="label"
                                  valueName="value"
                                />
                              )}
                              control={control}
                              name="reportType"
                              defaultValue={
                                getMemorizedFilters()?.reportType ?? 1
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">DDR</label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={ddrs || []}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  closeMenuOnSelect={true}
                                  fieldName="ddr"
                                  labelName="label"
                                  valueName="label"
                                  isClearable={true}
                                />
                              )}
                              control={control}
                              name="ddr"
                              defaultValue={getMemorizedFilters()?.ddr ?? ''}
                            />
                          </Col>
                          {reportType === 3 && (
                            <>
                              <Col md="6">
                                <label className="form-control-label">
                                  Agrupamentos
                                </label>
                                <Controller
                                  render={(props) => (
                                    <FlexSelect
                                      dataOptions={groupByOptions}
                                      isMulti={true}
                                      value={props.value}
                                      valueController={setValue}
                                      isClearable={true}
                                      closeMenuOnSelect={false}
                                      fieldName="groupby"
                                      labelName="label"
                                      valueName="value"
                                    />
                                  )}
                                  control={control}
                                  name="groupby"
                                  defaultValue={
                                    getMemorizedFilters()?.groupby ?? ''
                                  }
                                />
                              </Col>
                            </>
                          )}
                        </Row>

                        {reportType === 3 && (
                          <>
                            <Row className="mb-3">
                              <Col md="6">
                                <label className="form-control-label">
                                  Tempo máximo em espera para Nível de Serviço
                                </label>
                                <Controller
                                  placeholder="Segundos"
                                  as={Input}
                                  control={control}
                                  name="maxWaitTime"
                                  rules={{
                                    pattern: {
                                      value: /^\d+$/,
                                      message:
                                        'Tempo máximo é um campo numérico!'
                                    }
                                  }}
                                  defaultValue={
                                    getMemorizedFilters()?.maxWaitTime ?? ''
                                  }
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="maxWaitTime"
                                  render={({ message }) =>
                                    errorFormMessage(message)
                                  }
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3">
                              <Col className="md-6 mx-4">
                                <Controller
                                  name="allCalls"
                                  control={control}
                                  render={(props) => (
                                    <>
                                      <label className="form-control-label">
                                        <Input
                                          type="checkbox"
                                          onChange={(e) =>
                                            props.onChange(e.target.checked)
                                          }
                                          checked={props.value}
                                        />
                                        Considerar chamadas não atendidas no TME
                                        e Nível de Serviço
                                      </label>
                                    </>
                                  )}
                                  defaultValue={
                                    getMemorizedFilters()?.allCalls ?? false
                                  }
                                />
                              </Col>
                            </Row>
                          </>
                        )}
                        <Row className="mb-3">
                          <Col className="md-6 mx-4">
                            <div
                              style={{
                                display: 'flex',
                                gap: '20px',
                                alignItems: 'baseline'
                              }}
                            >
                              <Controller
                                name="disable"
                                control={control}
                                render={(props) => (
                                  <>
                                    <label className="form-control-label">
                                      <Input
                                        type="checkbox"
                                        onChange={(e) =>
                                          props.onChange(e.target.checked)
                                        }
                                        checked={props.value}
                                      />
                                      Mostrar desabilitados (Ramais, Filas)
                                    </label>
                                  </>
                                )}
                                defaultValue={
                                  getMemorizedFilters()?.disable ?? false
                                }
                              />
                              <UserFlexSelect
                                usersShowDisable={usersShowDisable}
                                setUsersShowDisable={setUsersShowDisable}
                                name={'Agentes'}
                              />
                            </div>
                          </Col>
                          <Col md="4" style={ImageButtonContainer}>
                            <div id="button_pdf">
                              {reportType !== 1 && (
                                <button
                                  style={ImageButton}
                                  name="pdf"
                                  onClick={() => setMedia('pdf')}
                                  disabled={disabledDownloadButtonCsvAndPdf(
                                    'pdf',
                                    quantity,
                                    limitGenerationPDF
                                  )}
                                >
                                  <Tooltip
                                    title={
                                      <p style={{ fontSize: '14px' }}>
                                        {messagemGeneratePdf}
                                      </p>
                                    }
                                    arrow
                                  >
                                    <img
                                      src={require('../../../../assets/img/pdf.png')}
                                      alt="pdf"
                                      style={ImageSize}
                                    />
                                  </Tooltip>
                                </button>
                              )}
                            </div>

                            <button
                              id="button_csv"
                              style={ImageButton}
                              onClick={() => setMedia('csv')}
                              disabled={disabledDownloadButtonCsvAndPdf(
                                'csv',
                                quantity,
                                limitGenerationPDF
                              )}
                            >
                              <Tooltip
                                title={
                                  <p style={{ fontSize: '14px' }}>
                                    {messagemGenerateCsv}
                                  </p>
                                }
                                arrow
                              >
                                <img
                                  src={require('../../../../assets/img/csv.png')}
                                  alt="csv"
                                  style={ImageSize}
                                />
                              </Tooltip>
                            </button>

                            {reportType === 1 && (
                              <button
                                id="button_xlsx"
                                style={ImageButton}
                                onClick={() => setMedia('xlsx')}
                                disabled={disabledDownloadButtonCsvAndPdf(
                                  'xlsx',
                                  quantity,
                                  limitGenerationPDF
                                )}
                              >
                                <Tooltip
                                  title={
                                    <p style={{ fontSize: '14px' }}>
                                      {messagemGenerateXlsx}
                                    </p>
                                  }
                                  arrow
                                >
                                  <img
                                    src={require('../../../../assets/img/xlsx.png')}
                                    alt="xlsx"
                                    style={ImageSize}
                                  />
                                </Tooltip>
                              </button>
                            )}
                          </Col>
                        </Row>

                        <Button
                          style={buttonStyle(systemConfiguration.primary_color)}
                          type="submit"
                        >
                          Buscar
                        </Button>
                        <Row className="mb-3">
                          <Col
                            md="3"
                            style={{ marginTop: '-45px', marginLeft: '110px' }}
                          >
                            <ItemPerPageSelect
                              valueController={setItemsPerPage}
                            ></ItemPerPageSelect>
                          </Col>
                        </Row>
                        <AudioMultipleDownload
                          handleMultiDownload={handleMultiDownload}
                          toggleMultiDownload={toggleMultiDownload}
                          isMultiDownload={isMultiDownload}
                          selectedRows={selectedRows}
                        />
                      </Form>
                    </>
                  )}
                  {loadingReport ? (
                    <Row className="justify-content-md-center">
                      <Loader
                        type="TailSpin"
                        color={systemConfiguration.primary_color}
                        height={100}
                        width={100}
                      />
                    </Row>
                  ) : (
                    <>
                      {reportType === 1 &&
                        ReportTypeAnalytical.listCallInAnalyticalDTO && (
                          <ReportAnalythical
                            dataReport={ReportTypeAnalytical}
                            totalRecords={quantity}
                            isMultiDownload={isMultiDownload}
                            handleOnSelect={handleOnSelect}
                            handleOnSelectAll={handleOnSelectAll}
                            selectedRows={selectedRows}
                          />
                        )}
                      {reportType === 2 &&
                        ReportTypeSynthetic.listCallForQueueDto && (
                          <ReportSynthetic dataReport={ReportTypeSynthetic} />
                        )}
                      {reportType === 3 &&
                        ReportTypeDetailedSynthetic.listCallDetailedSyntheticCallCenterDTO && (
                          <ReportDetailedSynthetic
                            dataReport={ReportTypeDetailedSynthetic}
                            dataToSend={dataToSend}
                            totalRecords={quantity}
                          />
                        )}
                    </>
                  )}
                  {(ReportTypeAnalytical.listCallInAnalyticalDTO ||
                    ReportTypeDetailedSynthetic.listCallDetailedSyntheticCallCenterDTO) && (
                    <Pagination
                      itemsCountPerPage={itemsPerPage}
                      activePage={activePage}
                      totalItemsCount={quantity}
                      onChange={handlePageChange.bind(this)}
                    />
                  )}
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ReceivedCallReport;
